export var AddPaymentCardErrorResultCode;
(function(AddPaymentCardErrorResultCode) {
    AddPaymentCardErrorResultCode[/**
     * Indicates that an unexpected API error occurred.
     */ "ApiError"] = "ApiError";
    AddPaymentCardErrorResultCode[/**
     * Indicates that an unexpected connector error occurred.
     */ "ConnectorError"] = "ConnectorError";
    AddPaymentCardErrorResultCode[/**
     * Indicates that the payment card was declined by the third-party payment provider.
     */ "CardDeclined"] = "CardDeclined";
})(AddPaymentCardErrorResultCode || (AddPaymentCardErrorResultCode = {}));

//# sourceMappingURL=add-payment-card-error-result-code.js.map